import { IMAGE_LOADER, type ImageLoaderConfig } from '@angular/common';
import type { Provider } from '@angular/core';

export function provideMapaImageLoader(): Provider {
  return {
    provide: IMAGE_LOADER,
    useValue: (config: ImageLoaderConfig) => {
      if (!config.width) return config.src;

      if (config.src.startsWith('https://images.unsplash.com/photo-')) {
        const url = new URL(config.src);
        url.searchParams.set('w', config.width.toString());
        return url.toString();
      }

      if (config.src.startsWith('/assets')) {
        const subpath = config.src.slice(8);
        return `/assets/__sharp/${subpath}?width=${config.width}`;
      }

      return config.src;
    }
  };
};